import { Injectable } from "@angular/core";
import { getColors } from "src/app/support/colors";
import { sntTranslate } from "src/app/support/translate";
import { marker } from "@jsverse/transloco-keys-manager/marker";

export type ColorWithName = { color: string; name: string };

@Injectable()
export class ColorService {
  private colorsMap: Map<string, string> = new Map<string, string>();

  private colorsMapWithNames: Map<string, ColorWithName> = new Map<
    string,
    ColorWithName
  >();

  constructor() {
    this.registerColorsWithNames();
  }

  private registerColorsWithNames(): void {
    const colors = [
      { name: sntTranslate(marker("Rosa Scuro")), value: "#ad1357" },
      { name: sntTranslate(marker("Rosa Vibrante")), value: "#d81b60" },
      { name: sntTranslate(marker("Rosso Scuro")), value: "#d50001" },
      { name: sntTranslate(marker("Rosso Pastello")), value: "#e67c73" },
      { name: sntTranslate(marker("Arancione Sanguigno")), value: "#f4511e" },
      { name: sntTranslate(marker("Arancione Scuro")), value: "#ef6c00" },
      { name: sntTranslate(marker("Arancione Vibrante")), value: "#f09300" },
      { name: sntTranslate(marker("Arancione Pastello")), value: "#f6bf25" },
      { name: sntTranslate(marker("Giallo Pastello")), value: "#e4c441" },
      { name: sntTranslate(marker("Giallo Vibrante")), value: "#c0ca33" },
      { name: sntTranslate(marker("Verde Vibrante")), value: "#7cb342" },
      { name: sntTranslate(marker("Verde Pastello")), value: "#33b679" },
      { name: sntTranslate(marker("Verde Scuro")), value: "#0b8043" },
      { name: sntTranslate(marker("Verde Smeraldo")), value: "#009688" },
      { name: sntTranslate(marker("Blu Vibrante")), value: "#039be5" },
      { name: sntTranslate(marker("Blu Pastello")), value: "#4285f4" },
      { name: sntTranslate(marker("Blu Scuro")), value: "#3f51b5" },
      { name: sntTranslate(marker("Viola Pastello")), value: "#7986cb" },
      { name: sntTranslate(marker("Viola Vibrante")), value: "#b39ddb" },
      { name: sntTranslate(marker("Viola Scuro")), value: "#9e69af" },
      { name: sntTranslate(marker("Viola Sanguigno")), value: "#8e24aa" },
      { name: sntTranslate(marker("Oro Scuro")), value: "#795548" },
      { name: sntTranslate(marker("Grigio Scuro")), value: "#616161" },
      { name: sntTranslate(marker("Grigio Pastello")), value: "#a79b8e" }
    ];

    colors.forEach(({ name, value }) => {
      this.colorsMapWithNames.set(value, {
        name,
        color: value
      });
    });
  }

  register(key: string, color: string): void {
    this.colorsMap.set(key, color);
  }

  getOrDefault(key: string): string {
    return this.colorsMap.get(key) || "rgb(148 163 184 / var(--tw-bg-opacity))";
  }

  get(key: string): string | undefined {
    return this.colorsMap.get(key);
  }

  list(): string[] {
    return getColors();
  }

  listWithName(): ColorWithName[] {
    return Array.from(this.colorsMapWithNames.values());
  }
}
